/** 特殊页面路由 */
export const HOME_ROUTE = '/main';
export const LOGIN_ROUTE = '/login';
